import React from "react"
import clsx from "clsx"
import IncidentalDepositPresenterAuthorizationAmount from "./IncidentalDepositPresenterAuthorizationAmount"
import IncidentalDepositPresenterAuthorizationMaintenance from "./IncidentalDepositPresenterAuthorizationMaintenance"

class IncidentalDepositPresenterGeneral extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true,
    })
    var incidentalDeposit = this.props.incidental_deposit
    return (
      <div className={tabClasses} id="general">
        {this.renderIncidentalDeposit(incidentalDeposit)}
      </div>
    );
  }

  renderIncidentalDeposit(incidentalDeposit) {
    if (incidentalDeposit && incidentalDeposit.deposit_type == null) {
      incidentalDeposit.deposit_type = 'store_a_valid_card';
    }

    return (
        <div >
          <div className="row">
            {this.renderName(incidentalDeposit)}
            {this.renderDepositType(incidentalDeposit)}
            {this.renderPreAuthorization(incidentalDeposit)}
            {this.renderDescription(incidentalDeposit)}
          </div>
          { 
            incidentalDeposit.deposit_type == 'store_a_valid_card' || incidentalDeposit.deposit_type == 'none' || incidentalDeposit.deposit_type == 'no_deposit'
              ? null
              : <div>
                  <br />
                  <div className="row">
                    {this.renderAmount(incidentalDeposit)}
                    {this.renderMaintainAuthorization(incidentalDeposit)}
                  </div>
                </div> 
          }
      </div>
    )
  }

  renderMaintainAuthorization() {
    return(
      <div className="col-md-6">
        <div className="panel default-panel">
          <div className="panel-body">
            <IncidentalDepositPresenterAuthorizationMaintenance {...this.props}/>
          </div>
        </div>
      </div>
    )
  }

  renderAmount() {
    return (
      <div className="col-md-6">
        <div className="panel default-panel">
          <div className="panel-body">
            <IncidentalDepositPresenterAuthorizationAmount {...this.props} />
          </div>
        </div>
      </div>
    );
  }

  renderName(incidentalDeposit) {
    return (
      <div className="col-md-3">
        <div className="form-group">
          <label>{I18n.t('name')}</label>
          <div>{incidentalDeposit.name}</div>
        </div>
      </div>
    )
  }

  renderDepositType(incidentalDeposit) {
    return(
      <div className="col-md-3">
        <div className="form-group">
        <label>{I18n.t('deposit_type')} <span className="ss-help help" title={I18n.t('incidental_deposit_type_help_text')}></span></label>
          <div>{I18n.t(incidentalDeposit.deposit_type)}</div>
        </div>
      </div>
    )
  }

  renderPreAuthorization(incidentalDeposit) {
    if(incidentalDeposit.pre_authorization == true) {
      var preAuthorization = "yes"
    } else {
      var preAuthorization = "no"
    }
    return (  
      <div className="col-md-3">
        <div className="form-group">
          <label>{I18n.t('validate_before_arrival')} <span className="ss-help help" title={I18n.t('pre_auth_helper_text')}></span> </label>
          <div>{I18n.t(preAuthorization)}</div>
        </div>
      </div> 
    )
  }

  renderDescription(incidentalDeposit) {
    return (
      <div className="col-md-3" key="incidental-description">
        <div className="form-group">
          <label>{I18n.t('description')}</label>
          <div dangerouslySetInnerHTML={{ __html: incidentalDeposit.description }} style={{ maxHeight: '200px', overflowY: 'scroll' }}></div>
        </div>
      </div>
    )
  }
}

export default IncidentalDepositPresenterGeneral